import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:4000/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hazmoona_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function unwrap(r) { return r?.data?.body; }
export default api;
